export const MONTHS = ['Ock', 'Sbt', 'Mar', 'Nsn', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
export const baseDateValues = { year: 2024, month: 0, day: 1 }
export const baseDate = new Date(baseDateValues.year, baseDateValues.month, baseDateValues.day)
export const monthNames = [
	"Ocak",
	"Şubat",
	"Mart",
	"Nisan",
	"Mayıs",
	"Haziran",
	"Temmuz",
	"Ağustos",
	"Eylül",
	"Ekim",
	"Kasım",
	"Aralık",
]


export const intervalMapping = {
	'hour': 'HOUR',
	'2hours': 'TWO_HOURS',
	'6hours': 'SIX_HOURS',
	'day': 'DAY',
	'week': 'WEEK',
	'2weeks': 'TWO_WEEKS',
	'month': 'MONTH',
	'3months': 'THREE_MONTHS',
	'year': 'YEAR',
	'10year': 'TEN_YEAR',
};


export const INTERVALS = {
	// SIX_HOURS: { value: "6hours", pixelWidth: 50 },
	DAY: { value: "day", pixelWidth: 60 },
	WEEK: { value: "week", pixelWidth: 70 },
	TWO_WEEKS: { value: "2weeks", pixelWidth: 90 },
	MONTH: { value: "month", pixelWidth: 80 },
	THREE_MONTHS: { value: "3months", pixelWidth: 100 },
	YEAR: { value: "year", pixelWidth: 90 },
	TWO_YEARS: { value: "2years", pixelWidth: 80 },
	FIVE_YEARS: { value: "5years", pixelWidth: 80 },
	TEN_YEAR: { value: "10years", pixelWidth: 80 },
	TWENTY_YEARS: { value: "20years", pixelWidth: 80 },
	FIFTY_YEARS: { value: "50years", pixelWidth: 80 },
	HUNDRED_YEAR: { value: "100years", pixelWidth: 100 },
	THOUSAND_YEAR: { value: "1000years", pixelWidth: 100 },
}



export const zoomLevels = [
	{ value: 'day', label: 'Günlük' },
	{ value: 'week', label: 'Haftalık' },
	// { value: '2weeks', label: '2 Haftalık' },
	{ value: 'month', label: 'Aylık' },
	{ value: '3months', label: '3 Aylık' },
	{ value: 'year', label: 'Yıllık' },
	{ value: '2years', label: '2 Yıllık' },
	{ value: '5years', label: '5 Yıllık' },
	{ value: '10years', label: '10 Yıllık' },
	{ value: '20years', label: '20 Yıllık' },
	{ value: '50years', label: '50 Yıllık' },
	{ value: '100years', label: '100 Yıllık' }
];
